module.exports = __webpack_public_path__ + "img/solution-chassisHIL-application-pic.61812020.png";